import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import SignIn from "../../components/SignIn";

const { Title } = Typography;

const Login = () => {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: 459, width: "100%" }}>
      <Title level={2} style={{ marginBottom: 43, textAlign: "center" }}>{t("loginPage.title")}</Title>
      <SignIn/>
    </div>
  );
};

export default Login;
